<template>
  <div
    ref="root"
    v-show="visible"
    class="popup qrcode"
  >
    <div class="content" ref="content">
      <div class="mb-1">
        お持ちのスマホでQRコードを読み取り、<br>
        サイトを開いて「ARで見る」を押すと、<br>
        擬似的に3Dモデルを現実世界に置いてみることができます。
      </div>
      <div>
        <img :src="qrcode" />
      </div>
    </div>
  </div>
</template>

<script>
import QRCode from "qrcode";
import PopupBase from "./PopupBase.vue";

export default {
  name: "QRCodePopup",
  extends: PopupBase,

  data () {
    return { qrcode: "" };
  },

  watch: {
    visible: function() {
      this.generateQRCode();
    }
  },

  mounted() {
    document.addEventListener("click", (e) => {
      if (this.visible) {
        // hide if a user clicks on the outside of a form
        const path = this.getPath(e);
        if (!path.includes(this.$refs.content)) {
          this.hide();
        }
      }
    });
  },

  methods: {
    generateQRCode() {
      const url = location.href;
      QRCode.toDataURL(url).then((qrUrl) => {
        this.qrcode = qrUrl;
      });
    }
  }
};
</script>

<style lang="scss" scoped>
.qrcode {
  .content {
    width: 450px;
    height: 300px;
    border-radius: 6px;
    font-size: 12px;
    font-weight: 700;

    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;

    .mb-1 {
      margin-bottom: .5rem;
    }
    .mb-2 {
      margin-bottom: 2rem;
    }

    input{
      border-radius: 6px;
      padding: 3px 5px;
    }

    button{
      background-color: #1bffc6;
      width: 110px;
      height: 36px;
      border-radius: 99em;
      border: none;
      font-size: 12px;
      font-weight: 700;
      cursor: pointer;
    }

    .detail-text{
      text-align: center;

      a{
        color: #000;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/QRCodePopup.vue